<p-dialog header="{{title}}" [modal]="true" [(visible)]="visible" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false" (onHide)="onClose()">
    <form class="dialog-form">
        <div class="row">
            <app-form *ngIf="form.length" [formConfig]="form" [hasButton]="false" (onChange)="valueChanged($event)"
                [validationErrors]="validationErrors" (onSubmit)="onSave($event)"></app-form>
        </div>
        <div class="dialog-footer d-flex justify-content-between">
            <p-button label="Cancel" [outlined]="true" (click)="onClose()" />
            <p-button label="Add" (click)="onSave()" />
        </div>
    </form>
</p-dialog>
